import React from 'react';
import { useState } from 'react';
import classNames from 'classnames';
import FullScreenOverlay from '../../fullScreenOverlay/FullScreenOverlay';
var Resizer = function (_a) {
    var value = _a.value, onResize = _a.onResize, min = _a.min, max = _a.max, _b = _a.displayDefaultResizeHandle, displayDefaultResizeHandle = _b === void 0 ? true : _b, onStartResize = _a.onStartResize, onStopResize = _a.onStopResize, className = _a.className;
    var _c = useState(false), mouseOver = _c[0], setMouseOver = _c[1];
    var _d = useState(false), isResizing = _d[0], setIsResizing = _d[1];
    var _e = useState(null), lastCursorPosition = _e[0], setLastCursorPosition = _e[1];
    var handleMouseDown = function (e) {
        setIsResizing(true);
        setLastCursorPosition(e.pageX);
        onStartResize && onStartResize();
    };
    var handleMouseUp = function () {
        setIsResizing(false);
        setLastCursorPosition(null);
        onStopResize && onStopResize();
    };
    var handleMouseMove = function (e) {
        if (isResizing && lastCursorPosition !== null) {
            e.stopPropagation();
            e.preventDefault();
            var mouseDeltaX = e.pageX - lastCursorPosition;
            var updatedValue = clampValue(value + mouseDeltaX);
            var valueDelta = updatedValue - value;
            setLastCursorPosition(lastCursorPosition + valueDelta);
            onResize(valueDelta);
        }
    };
    var clampValue = function (valueToClamp) {
        if (min !== undefined && valueToClamp < min) {
            return min;
        }
        else if (max !== undefined && valueToClamp > max) {
            return max;
        }
        else {
            return valueToClamp;
        }
    };
    return (React.createElement("div", { className: classNames('resizerHolder', className), onMouseEnter: function () { return setMouseOver(true); }, onMouseLeave: function () { return setMouseOver(false); }, onMouseDown: handleMouseDown },
        isResizing &&
            React.createElement("div", { onMouseMove: handleMouseMove, onMouseUp: handleMouseUp },
                React.createElement(FullScreenOverlay, null)),
        React.createElement("div", { className: classNames('resizer', { hover: mouseOver }, { dragging: isResizing }) }, displayDefaultResizeHandle &&
            React.createElement("div", { style: {
                    backgroundColor: "" + (mouseOver ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.32)'),
                    borderRadius: '1px',
                    height: '50px',
                    position: 'absolute',
                    top: 'calc(50% - 25px)',
                    width: '2px',
                } }))));
};
export default Resizer;
//# sourceMappingURL=Resizer.js.map